import { HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError, defer, of } from 'rxjs';
import { tap, catchError, switchMap, map } from 'rxjs/operators';
import { CompanyToken } from 'src/app/Models/Access/company-token-result';
import { LastAccessResult } from 'src/app/Models/Access/last-access-result';
import { GetErpUsersResult } from 'src/app/Models/Account/getErpUser-result';
import { GetUserInfoResult, userDataObj } from 'src/app/Models/Account/getUserInfo-result';
import { GetUsersResult } from 'src/app/Models/Account/user-data';
import Base from 'src/app/Models/Base/base';
import Storage from 'src/app/Models/Base/storage';
import { ListTwoFactorByUserResult } from 'src/app/Models/TwoFactor/list-twoFactorByUser-result';
import { AppStateService } from '../AppState/app-state.service';
import { ConstService } from '../Const/const.service';
import { setLocalStorage } from 'npx-arc-ui/utils';
export class UserService {
  constructor(private appState: AppStateService) {}

  SendCode(twoFactorCode: string, email: string = '', token?: string) {
    this.appState.loading = true;
    let 
    url = `${ConstService.URLApi}/User/SendCode`,
    params = new HttpParams().set('twoFactorCode', twoFactorCode),
    headers = new HttpHeaders();
    if(!!email.length){
      params = params.append('email', email)
    }
    if(token && !!token.length){
      headers = headers.append('Authorization', `Bearer ${token}`)
    }
    return this.appState.http.get<Base>(url, { headers, params }).pipe(
    tap(({success, message}) => {
      this.appState.loading = false;
        if (!success) {
          throw(message)
        }
      }),
      catchError((err) => {
      this.appState.loading = false;
        this.appState.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err)
      })
    );
  }

  VerifyCode(code: string, twoFactorCode: string, origin=0, token?: string) {
    this.appState.loading = true;
    let url = `${
      ConstService.URLApi
    }/User/VerifyCode?code=${code}&twoFactorCode=${twoFactorCode}&origin=${origin}`;
    let headers = new HttpHeaders().set(
      'Content-Type',
      'application/octet-stream'
    );
    if(token && !!token.length){
      headers = headers.append('Authorization', `Bearer ${token}`)
    }
    return this.appState.http.get<CompanyToken>(url, { headers }).pipe(
      tap(({success, token, message}) => {
        this.appState.loading = false;
        if (success) {  
            !!token.length && setLocalStorage(Storage.TOKEN, token);
          } 
          else {
            throw(message)
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err)
      })
    );
  }

  CheckUser(email: string) {
    this.appState.loading = !false;
    let url = `${ConstService.URLApi}/User/CheckUser?email=${email}`;
    return this.appState.http.get<Base>(url).pipe(
      switchMap(c =>{
        return defer(() => c.success
        ? this.ListForgotPasswordTwoFactor(email)
        : of(c))
      }),
      tap(c =>{
        this.appState.loading = false;
        if(!c.success){
          throw(c.message)
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err)
      })
    )
  }

  public ListForgotPasswordTwoFactor(email: string) {
    let url = `${ConstService.URLApi}/User/ListForgotPasswordTwoFactor?email=${email}`;
    return this.appState.http.get<ListTwoFactorByUserResult>(url).pipe(
      tap((res) => {
        if (res.success) {
          this.appState.ListTwoFactorForgotResult = res;
        } else {
          throw(res.message);
        }
      }),
      catchError((err) => {
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  public VerifyForgotYourPasswordAsync({
    email,
    signingCode,
    newpass,
    codeSet
  }: any): void {
    this.appState.loading = true;
    var url: string = `${ConstService.URLApi}/User/VerifyForgotYourPasswordAsync`;
    const payload = {
      email,
      code: signingCode,
      twoFactorCode: codeSet,
      password: newpass,
    };
    this.appState.http.post<Base>(url, payload)
    .subscribe(({success, message}) => {
      this.appState.loading = false;
      if (success) {
        this.appState.showMiniMessage('Proceso éxitoso', 'success');
        localStorage.clear();
        this.appState.router.navigateByUrl('');
      } 
      else {
        this.appState.showMiniMessage(message, 'error');
      }
    });
  }

  GetListUsers() {
    this.appState.loading = true;
    let url = `${ConstService.URLApi}/User/GetUsers`;
    const { itemsPerPage, page, filter } = this.appState.folder;
    let params = new HttpParams()
      .set('itemsPerPage', itemsPerPage)
      .set('pageNumber', page);
    if (filter && !!filter.length) {
      params = params.append('name', this.appState.folder.filter);
    }
    return this.appState.http.get<GetUsersResult>(url, { params })
    .pipe(
      tap(res => {
        if (res.success) {
          const userList = res.userList.map(c => {
            const { isAdmin, hasCompanyAccess } = c
            return {
              ...c,
              permissions: [isAdmin, hasCompanyAccess]
            }
          });
          this.appState.GetUsersResultVar = {...res, userList};
          this.appState.loading = false;
          this.appState.folder.totalItems = res.totalItems;
          if (
            this.appState.folder.totalItems > 0 &&
            this.appState.folder.page * this.appState.folder.itemsPerPage >
              this.appState.folder.totalItems + this.appState.folder.itemsPerPage
          ) {
            this.appState.folder.page = parseInt(
              (
                (this.appState.folder.totalItems - 1) /
                this.appState.folder.itemsPerPage
              ).toString()
            );
            this.appState.ListPaginator.pageIndex = this.appState.folder.page;
            this.appState.folder.page++;
            this.GetListUsers();
            return;
          }
        } else {
          this.appState.loading = false;
          throw(res.message);
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err)
      })
    );
  }

  GetLastAccess() {
    let url = `${ConstService.URLApi}/User/GetLastAccess`;
    return this.appState.http.get<LastAccessResult>(url)
    .pipe(
      tap(({ success, isFirstAccess, lastAccess, message }) => {
        if (success) {
          if (!isFirstAccess) {
            var date = lastAccess.split('T')[0];
            date =
              date.split('-')[2] +
              '-' +
              date.split('-')[1] +
              '-' +
              date.split('-')[0];
            setLocalStorage(
              Storage.LAST_ACCESS,
              'Tu último acceso fue el ' + date.toString()
            );
          }
        } else {
          throw message
        };
      }),
      catchError((err) => {
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  public UpdatePasswordWithAdmin(newPassword: string, accountID: string): void {
    this.appState.loading = true;
    var url: string = `${ConstService.URLApi}/User/UpdatePasswordWithAdmin`;
    this.appState.http.post<Base>(url, { newPassword, accountID })
    .subscribe(({success, message}) => {
      if (success) {
        this.appState.loading = false;
        this.appState.showMiniMessage(message, 'success');
      } else {
        this.appState.loading = false;
        this.appState.showMiniMessage(message, 'error');
      }
      this.appState.dialog.closeAll();
    },
    err =>{
      this.appState.loading = false;
      this.appState.dialog.closeAll();
      this.appState.showMiniMessage('Ocurrio un error interno', 'error');
    });
  }


  public GetUserInfo(accountID: string) {
    this.appState.loading = true;
    var url: string = `${ConstService.URLApi}/User/GetUserInfo`;
    return this.appState.http.post<GetUserInfoResult>(url, { accountID }).pipe(
      tap(res => {
        this.appState.loading = false;
        if (res.success) {
          this.appState.GetUserInfoResult = res;
        } else {
          throw(res.message)
        }
      }),
      catchError(err =>{
        this.appState.showMiniMessage(err || 'Ocurrio un error interno', 'error');
        return throwError(err);
      })
    );
  }

  public UpdateUser(data: userDataObj): void {
    this.appState.loading = true;
    var url: string = `${ConstService.URLApi}/User/UpdateUser`;
    var body: any = new Object();
    body = {
      accountID: data.accountID,
      rut: data.rut,
      firstName: data.firstName,
      lastName: data.lastName,
      firstEmail: data.firstEmail,
      secondEmail: data.secondEmail,
      phone: data.phone,
    };
    this.appState.http.post<Base>(url, body).subscribe((res: any) => {
      if (res.success) {
        this.appState.loading = false;
        this.appState.showMiniMessage('Proceso éxitoso', 'success');
      } else {
        this.appState.loading = false;
        this.appState.showMiniMessage(res.message, 'error');
      }
    });
  }

  public CreateAccount(data: any): void {
    this.appState.loading = true;
    var url: string = `${ConstService.URLApi}/User/InsertUser`;
    var body: any = new Object();
    body = {
      erpUserId: data.erpUserId,
      rut: data.rut,
      firstName: data.firstName,
      password: data.password,
      lastName: data.lastName,
      firstEmail: data.firstEmail,
      secondEmail: data.secondEmail,
      phone: data.phone,
    };
    this.appState.http.post<Base>(url, body).subscribe((res: any) => {
      if (res.success) {
        this.appState.loading = false;

        this.appState.showMiniMessage('Proceso éxitoso', 'success');
      } else {
        this.appState.loading = false;
        this.appState.showMiniMessage(res.message, 'error');
      }
    });
  }

  GetErpUsers(filter: string = '') {
    let url = `${ConstService.URLApi}/User/GetErpUsers`;
    let params = new HttpParams()
      .set('itemsPerPage', 5)
      .set('pageNumber', 0);
    if (filter !== '') {
      params = params.append('name', filter);
    }
    return this.appState.http.get<GetErpUsersResult>(url, { params }).pipe(
    map(({userList, success}) => {
        if (success && !!userList.length) {
           return userList.filter(c => c.name.toLowerCase().includes(filter.toLowerCase())) 
        }
        else
          return []
      }),
      catchError((err) => {
        return throwError(
          err || 'Error interno, por favor intentar más tarde.'
        );
      })
    );
  }
}
